import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useLazyQuery } from '@apollo/client';
import KEY_ASSESSMENT_ENRICHMENT_REPORT_QUERY from 'graph/reports/key-assessment-enrichment-report-query';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { getQueryVariables } from 'components/ReportsModule/utils/report-param-utils';
import SpotChecksCompletedCard from './SpotChecksCompletedCard';
import EnrichmentActivityCard from './EnrichmentActivityCard';
import AssessmentAcceleratorCard from './AssessmentAcceleratorCard';
import { KeyAssessmentAndEnrichmentActivityReportResult } from 'types/schema-generated-types';

const ClassroomAssessmentEnrichmentCards: React.FC = () => {
  const classes = useStyles();
  const [{ entityId, entityType, dateRange }] = useReportQueryParams();
  const [fetchReport, { data, loading }] = useLazyQuery<{
    keyAssessmentAndEnrichmentActivityReport: KeyAssessmentAndEnrichmentActivityReportResult;
  }>(KEY_ASSESSMENT_ENRICHMENT_REPORT_QUERY);

  useEffect(() => {
    fetchReport({ variables: getQueryVariables({ entityId, entityType, dateRange }) });
  }, [fetchReport, entityId, entityType, dateRange]);

  const { spotChecks, enrichmentActivities, teacherCreatedActivities, assessmentAccelerator } =
    data?.keyAssessmentAndEnrichmentActivityReport || {};

  return (
    <section>
      <Grid container wrap="wrap" spacing={2} className={classes.container} justify="center">
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <SpotChecksCompletedCard loading={loading} spotChecks={spotChecks} />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <AssessmentAcceleratorCard
            loading={loading}
            data={assessmentAccelerator}
            entityType={entityType}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <EnrichmentActivityCard
            enrichmentActivities={enrichmentActivities}
            teacherCreatedActivities={teacherCreatedActivities}
          />
        </Grid>
      </Grid>
    </section>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  container: { marginBottom: theme.spacing(2) }
}));

export default ClassroomAssessmentEnrichmentCards;
